import { Download } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    Grid,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useMediaQuery,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { MOBILE_MEDIA_QUERY } from "constants/mediaQueries";
import { useDispatch, useSelector } from "react-redux";
import { setShowInvoiceAttachmentsDialogue } from "redux/actions/generalActions";
import { tableHeaderProps } from "styled/props/tableProps";
import styledDialogueSX from "styled/styledSXProperties/styledDialogueSX";
import {
    downloadAllAttachments,
    downloadInvoiceAttachment,
} from "utils/invoiceAttachmentUtils";

const GreyIconButton = styled(IconButton)(({ theme }) => ({
    color: theme.palette.grey[600],
}));

const InvoiceAttachmentsDialogue = () => {
    const dispatch = useDispatch();
    let attachments = useSelector((state) =>
        state.general.invoiceAttachments &&
        state.general.invoiceAttachments?.length > 0
            ? state.general.invoiceAttachments.filter(
                  (item) => !item?.FILENAME?.endsWith(".msg") //file name .msg removed as there is no requirement to handle the email attachments from iBuy
              )
            : []
    );
    const invoice = useSelector((state) => state.general.invoice);
    const showInvoiceAttachmentsDialogue = useSelector(
        (state) => state.general.showInvoiceAttachmentsDialogue
    );

    const onClickClose = () => {
        dispatch(setShowInvoiceAttachmentsDialogue(false));
    };

    const isDesktop = useMediaQuery(MOBILE_MEDIA_QUERY);

    return (
        <Dialog
            maxWidth="xl"
            open={showInvoiceAttachmentsDialogue}
            fullScreen={!isDesktop}
        >
            <DialogContent sx={styledDialogueSX}>
                <Grid container spacing={2} marginBottom="16px">
                    <Grid item xs={8}>
                        <Box display="flex" flexDirection="row">
                            <Typography variant="h3" marginBottom={"4px"}>
                                {attachments &&
                                    invoice &&
                                    attachments.length > 0 && (
                                        <>
                                            Invoice Attachments:
                                            {" " + invoice.INVOICE_NUM} | Total
                                            Attachments:{" "}
                                            {" " + attachments.length}
                                        </>
                                    )}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid
                        container
                        item
                        xs={3}
                        justifyContent="flex-end"
                        alignContent="center"
                    >
                        <Button
                            disabled={false}
                            onClick={() => {
                                downloadAllAttachments(attachments, dispatch);
                            }}
                            variant="contained"
                            color="secondary"
                            size={isDesktop ? "medium" : "small"}
                        >
                            Download All Attachments
                        </Button>
                    </Grid>
                    <Grid
                        container
                        item
                        xs={1}
                        justifyContent="flex-end"
                        alignContent="center"
                    >
                        <IconButton
                            onClick={onClickClose}
                            aria-label="closeInvoiceAttachmentsDialogue"
                            sx={{ mt: "-5px" }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                    <Grid item xs={12}>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead sx={{ color: "black" }}>
                                    <TableRow>
                                        <TableCell
                                            style={{
                                                width: "25%",
                                            }}
                                        >
                                            <Typography {...tableHeaderProps}>
                                                Download Attachment(s)
                                            </Typography>
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                width: "25%",
                                            }}
                                        >
                                            <Typography {...tableHeaderProps}>
                                                Attachment Name
                                            </Typography>
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                width: "25%",
                                            }}
                                        >
                                            <Typography {...tableHeaderProps}>
                                                Description
                                            </Typography>
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                width: "25%",
                                            }}
                                        >
                                            <Typography {...tableHeaderProps}>
                                                Type
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {attachments.length > 0 &&
                                        attachments.map((attachment, index) => (
                                            <TableRow key={index}>
                                                <TableCell align="center">
                                                    <GreyIconButton
                                                        onClick={() => {
                                                            downloadInvoiceAttachment(
                                                                attachment,
                                                                dispatch
                                                            );
                                                        }}
                                                    >
                                                        {" "}
                                                        <Download />
                                                    </GreyIconButton>
                                                </TableCell>
                                                <TableCell align="center">
                                                    {attachment.TITLE &&
                                                    attachment.TITLE.trim() !==
                                                        ""
                                                        ? attachment.TITLE
                                                        : attachment.FILENAME}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {attachment.DESCRIPTION}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {attachment.ATTACHMENT_TYPE}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default InvoiceAttachmentsDialogue;
